// NEXTJS doesnt work with redux dev tools as of 16/08/2023 so using this
export const loggingMiddleware = ({ getState }: any) => {
	return (next: any) => (action: any) => {
		const oldState = { ...getState() };
		Object.freeze(oldState);
		const result = next(action);
		// if (process.env.NODE_ENV === 'development') {
		// 	const theDiff = diff(oldState, getState());
		// 	console.log('%c DIFF: ', 'background: #222; color: #bada55', theDiff);
		// 	console.log('%c STATE: ', 'background: #222; color: #0055ff', getState());
		// }
		return result;
	};
};
